import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AdminPartsCRM = lazy(() => import("@/pages/admin/AdminPartsCRM"));

function AdminPartsCRMRoute() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-background" />}>
      <AdminPartsCRM />
    </Suspense>
  );
}

export const Route = createFileRoute("/_adminLayout/admin/parts/crm")({
  component: AdminPartsCRMRoute,
});
